import $ from '../lib/jquery';
import './owl-carousel-2.1.6';

/**
 * AutoHeight Plugin
 * @version 2.1.0
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
/**
 * Creates the auto height plugin.
 * @class The Auto Height Plugin
 * @param {Owl} carousel - The Owl Carousel
 */
export const AutoHeight = function (carousel) {
  /**
   * Reference to the core.
   * @protected
   * @type {Owl}
   */
  this._core = carousel;

  /**
   * All event handlers.
   * @protected
   * @type {Object}
   */
  this._handlers = {
    'initialized.owl.carousel refreshed.owl.carousel': $.proxy(function (e) {
      if (e.namespace && this._core.settings.autoHeight) {
        this.update();
      }
    }, this),
    'changed.owl.carousel': $.proxy(function (e) {
      if (e.namespace && this._core.settings.autoHeight && e.property.name == 'position') {
        this.update();
      }
    }, this),
    'loaded.owl.lazy': $.proxy(function (e) {
      if (e.namespace && this._core.settings.autoHeight
        && e.element.closest('.' + this._core.settings.itemClass)
          .index() === this._core.current()) {
        this.update();
      }
    }, this)
  };

  // set default options
  this._core.options = $.extend({}, AutoHeight.Defaults, this._core.options);

  // register event handlers
  this._core.$element.on(this._handlers);
};

/**
 * Default options.
 * @public
 */
AutoHeight.Defaults = {
  autoHeight: false,
  autoHeightClass: 'owl-height'
};

/**
 * Updates the view.
 */
AutoHeight.prototype.update = function () {
  var start = this._core._current,
    end = start + this._core.settings.items,
    visible = this._core.$stage.children()
      .toArray()
      .slice(start, end),
    heights = [],
    maxheight = 0;

  $.each(visible, function (index, item) {
    heights.push($(item)
      .height());
  });

  maxheight = Math.max.apply(null, heights);

  this._core.$stage.parent()
    .height(maxheight)
    .addClass(this._core.settings.autoHeightClass);
};

AutoHeight.prototype.destroy = function () {
  var handler,
    property;

  for (handler in this._handlers) {
    this._core.$element.off(handler, this._handlers[handler]);
  }
  for (property in Object.getOwnPropertyNames(this)) {
    typeof this[property] != 'function' && (this[property] = null);
  }
};

$.fn.owlCarousel.Constructor.Plugins.AutoHeight = AutoHeight;
